module.exports = __webpack_public_path__ + "img/my-off.d492d0da.png";